import { render, staticRenderFns } from "./votingContent.vue?vue&type=template&id=1682b428&scoped=true"
import script from "./votingContent.vue?vue&type=script&lang=js"
export * from "./votingContent.vue?vue&type=script&lang=js"
import style0 from "./votingContent.vue?vue&type=style&index=0&id=1682b428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682b428",
  null
  
)

export default component.exports